import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'ui/gridSystem';
import Modal, { stopEvent } from 'ui/components/Modals/Modal';
import { ModalGlobalContainer } from 'ui/components/Modals/Modal.style';
import { Button } from 'ui/atoms';
import { MODAL_CLOSE } from 'redux/actions';
import ProDisplay from 'ui/typography/proDisplay';
import { ModalWrapper } from '../InviteFriendModal/style';
import {
  Title,
  ButtonsWrapper,
  ContentWrapper,
  BtnContainer,
  Icon
} from './style';
import { SHARE_COMMENT } from 'redux/actions/playlist';

const modalId = 'ShareModal';

const ShareModal = ({ onClose, shareRequest, shareComment }) => {

  const onSubmit = () => {
    onClose();
    shareComment(shareRequest);
  };

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ContentWrapper>
              <Icon className="icon-close-x" onClick={onClose} />
              <Title>
                <ProDisplay type="modalTitle">
                  Vuoi condividere questo elemento nella bacheca?
                </ProDisplay>
              </Title>
              <ButtonsWrapper>
                <BtnContainer>
                  <Button
                    onClick={onClose}
                    type={Button.TYPE.SECONDARY}
                    text="Annulla"
                  />
                </BtnContainer>
                <BtnContainer>
                  <Button
                    onClick={onSubmit}
                    type={Button.TYPE.PRIMARY}
                    text="Condividi"
                  />
                </BtnContainer>
              </ButtonsWrapper>
            </ContentWrapper>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

ShareModal.propTypes = {
  onClick: PropTypes.func,
  // HOC (connect, dispatch)
  onClose: PropTypes.func.isRequired,
  shareRequest: PropTypes.object,
  shareComment: PropTypes.func
};

ShareModal.id = modalId;
export default connect(
  state => {
    return state;
  },
  dispatch => ({
    onClose: () => dispatch({ type: MODAL_CLOSE }),
    shareComment: payload => dispatch({ type: SHARE_COMMENT._REQUEST, payload })
  })
)(ShareModal);
